export default __webpack_public_path__ + "static/media/information--children--g2.aede4dee.png";